export default __webpack_public_path__ + "static/missionary-de391e68f241098c9535b4311c07adce.svg";